const seasonicImagePath = `/images/products/seasonic-industrial`;

const makeSeasonicPsu = ({
  id,
  label,
  formFactor,
  watt,
  cert,
  extra = ``,
  specs,
  productUrl = `https://industrial.seasonic.com/de/products/`,
  datasheetUrl = null,
}) => ({
  id,
  brand: `Seasonic`,
  name: { de: label, en: label, es: label },
  description: {
    de: `Industrielles ${formFactor}-Netzteil mit ${watt}, ${cert}${extra ? `, ${extra}` : ``}.`,
    en: `Industrial ${formFactor} power supply with ${watt}, ${cert}${extra ? `, ${extra}` : ``}.`,
    es: `Fuente industrial ${formFactor} de ${watt}, ${cert}${extra ? `, ${extra}` : ``}.`,
  },
  category: `Industrial PSU`,
  application: `power`,
  specs,
  images: [`${seasonicImagePath}/${id}.jpg`],
  productUrl,
  datasheetUrl,
  price: null,
});

export const seasonicProducts = [
  makeSeasonicPsu({
    id: `ssp-1000rs`,
    label: `SSP-1000RS`,
    formFactor: `ATX`,
    watt: `1000W`,
    cert: `80 PLUS Gold`,
    extra: `full range, 80 mm fan`,
    specs: `ATX | 1000W | 80 PLUS Gold | Full Range | 80 mm Fan`,
    productUrl: `https://industrial.seasonic.com/product/atx-rs/`,
    datasheetUrl: `https://industrial.seasonic.com/wp-content/uploads/sites/2/2024/04/SSP-1000-850-750-650-RS.pdf`,
  }),

  makeSeasonicPsu({
    id: `ssp-250sub`,
    label: `SSP-250SUB`,
    formFactor: `Flex ATX`,
    watt: `250W`,
    cert: `80 PLUS Bronze`,
    extra: `fully modular, full range`,
    specs: `Flex ATX | 250W | 80 PLUS Bronze | Fully Modular | Full Range`,
    productUrl: `https://industrial.seasonic.com/product/flex-sub/`,
    datasheetUrl: `https://industrial.seasonic.com/wp-content/uploads/sites/2/2024/04/SSP-250-300-SUB.pdf`,
  }),

  makeSeasonicPsu({
    id: `ssp-300sfb`,
    label: `SSP-300SFB`,
    formFactor: `SFX`,
    watt: `300W`,
    cert: `80 PLUS Bronze`,
    extra: `full range`,
    specs: `SFX | 300W | 80 PLUS Bronze | Full Range`,
    productUrl: `https://industrial.seasonic.com/product/sfx-sfb/`,
    datasheetUrl: `https://industrial.seasonic.com/wp-content/uploads/sites/2/2024/04/SSP-300-SFB.pdf`,
  }),

  makeSeasonicPsu({
    id: `ssp-300sfg`,
    label: `SSP-300SFG`,
    formFactor: `SFX`,
    watt: `300W`,
    cert: `80 PLUS Gold`,
    extra: `fixed cables`,
    specs: `SFX | 300W | 80 PLUS Gold | Fixed Cables`,
    productUrl: `https://industrial.seasonic.com/de/products/`,
    datasheetUrl: null,
  }),

  makeSeasonicPsu({
    id: `ssp-300sub`,
    label: `SSP-300SUB`,
    formFactor: `Flex ATX`,
    watt: `300W`,
    cert: `80 PLUS Bronze`,
    extra: `fully modular, full range`,
    specs: `Flex ATX | 300W | 80 PLUS Bronze | Fully Modular | Full Range`,
    productUrl: `https://industrial.seasonic.com/product/flex-sub/`,
    datasheetUrl: `https://industrial.seasonic.com/wp-content/uploads/sites/2/2024/04/SSP-250-300-SUB.pdf`,
  }),

  makeSeasonicPsu({
    id: `ssp-300sug-rev-a2w`,
    label: `SSP-300SUG Rev. A2W`,
    formFactor: `Flex ATX`,
    watt: `300W`,
    cert: `80 PLUS Gold`,
    extra: `full range, fully modular`,
    specs: `Flex ATX | 300W | 80 PLUS Gold | Fully Modular | Full Range | Rev. A2W`,
    productUrl: `https://industrial.seasonic.com/de/products/`,
    datasheetUrl: null,
  }),

  makeSeasonicPsu({
    id: `ssp-300sug-rev-b1w`,
    label: `SSP-300SUG Rev. B1W`,
    formFactor: `Flex ATX`,
    watt: `300W`,
    cert: `80 PLUS Gold`,
    extra: `full range, fully modular`,
    specs: `Flex ATX | 300W | 80 PLUS Gold | Fully Modular | Full Range | Rev. B1W`,
    productUrl: `https://industrial.seasonic.com/de/products/`,
    datasheetUrl: null,
  }),

  makeSeasonicPsu({
    id: `ssp-300tbs`,
    label: `SSP-300TBS`,
    formFactor: `TFX`,
    watt: `300W`,
    cert: `80 PLUS Bronze`,
    extra: `fixed cables`,
    specs: `TFX | 300W | 80 PLUS Bronze | Fixed Cables`,
    productUrl: `https://industrial.seasonic.com/product/tfx-tbs/`,
    datasheetUrl: null,
  }),

  makeSeasonicPsu({
    id: `ssp-300tgs`,
    label: `SSP-300TGS`,
    formFactor: `TFX`,
    watt: `300W`,
    cert: `80 PLUS Gold`,
    extra: `fixed cables`,
    specs: `TFX | 300W | 80 PLUS Gold | Fixed Cables`,
    productUrl: `https://industrial.seasonic.com/de/products/`,
    datasheetUrl: null,
  }),

  makeSeasonicPsu({
    id: `ssp-350es2`,
    label: `SSP-350ES2`,
    formFactor: `ATX`,
    watt: `350W`,
    cert: `80 PLUS Bronze`,
    extra: `full range`,
    specs: `ATX | 350W | 80 PLUS Bronze | Full Range`,
    productUrl: `https://industrial.seasonic.com/product/atx-es2/`,
    datasheetUrl: null,
  }),

  makeSeasonicPsu({
    id: `ssp-350gt`,
    label: `SSP-350GT`,
    formFactor: `ATX`,
    watt: `350W`,
    cert: `80 PLUS Gold`,
    extra: `industrial PSU`,
    specs: `ATX | 350W | 80 PLUS Gold`,
    productUrl: `https://industrial.seasonic.com/de/products/`,
    datasheetUrl: null,
  }),

  makeSeasonicPsu({
    id: `ssp-350se`,
    label: `SSP-350SE`,
    formFactor: `ATX`,
    watt: `350W`,
    cert: `80 PLUS Bronze`,
    extra: `full range, 80 mm fan`,
    specs: `ATX | 350W | 80 PLUS Bronze | Full Range | 80 mm Fan`,
    productUrl: `https://industrial.seasonic.com/de/products/`,
    datasheetUrl: null,
  }),

  makeSeasonicPsu({
    id: `ssp-350st`,
    label: `SSP-350ST`,
    formFactor: `ATX`,
    watt: `350W`,
    cert: `80 PLUS Bronze`,
    extra: `PFC F3, 120 mm fan`,
    specs: `ATX | 350W | 80 PLUS Bronze | PFC F3 | 120 mm Fan`,
    productUrl: `https://industrial.seasonic.com/de/products/`,
    datasheetUrl: null,
  }),

  makeSeasonicPsu({
    id: `ssp-350st2`,
    label: `SSP-350ST2`,
    formFactor: `ATX`,
    watt: `350W`,
    cert: `80 PLUS Bronze`,
    extra: `PFC F3, 120 mm fan, full range APFC`,
    specs: `ATX | 350W | 80 PLUS Bronze | PFC F3 | 120 mm Fan | Full Range APFC`,
    productUrl: `https://industrial.seasonic.com/de/products/`,
    datasheetUrl: null,
  }),

  makeSeasonicPsu({
    id: `ssp-400es2`,
    label: `SSP-400ES2`,
    formFactor: `ATX`,
    watt: `400W`,
    cert: `80 PLUS Bronze`,
    extra: `full range`,
    specs: `ATX | 400W | 80 PLUS Bronze | Full Range`,
    productUrl: `https://industrial.seasonic.com/product/atx-es2/`,
    datasheetUrl: null,
  }),

  makeSeasonicPsu({
    id: `ssp-400et2`,
    label: `SSP-400ET2`,
    formFactor: `ATX`,
    watt: `400W`,
    cert: `80 PLUS Bronze`,
    extra: `full range`,
    specs: `ATX | 400W | 80 PLUS Bronze | Full Range`,
    productUrl: `https://industrial.seasonic.com/product/atx-et2/`,
    datasheetUrl: `https://industrial.seasonic.com/wp-content/uploads/sites/2/2024/04/SSP-600-500-400-350ET2.pdf`,
  }),

  makeSeasonicPsu({
    id: `ssp-400js`,
    label: `SSP-400JS`,
    formFactor: `ATX`,
    watt: `400W`,
    cert: `80 PLUS Gold`,
    extra: `industrial PSU`,
    specs: `ATX | 400W | 80 PLUS Gold`,
    productUrl: `https://industrial.seasonic.com/de/products/`,
    datasheetUrl: null,
  }),

  makeSeasonicPsu({
    id: `ssp-400jt`,
    label: `SSP-400JT`,
    formFactor: `ATX`,
    watt: `400W`,
    cert: `80 PLUS Gold`,
    extra: `industrial PSU`,
    specs: `ATX | 400W | 80 PLUS Gold`,
    productUrl: `https://industrial.seasonic.com/de/products/`,
    datasheetUrl: null,
  }),

  makeSeasonicPsu({
    id: `ssp-450rt`,
    label: `SSP-450RT`,
    formFactor: `PS2`,
    watt: `450W`,
    cert: `80 PLUS Gold`,
    extra: `industrial PSU`,
    specs: `PS2 | 450W | 80 PLUS Gold`,
    productUrl: `https://industrial.seasonic.com/de/products/`,
    datasheetUrl: null,
  }),

  makeSeasonicPsu({
    id: `ssp-500es2`,
    label: `SSP-500ES2`,
    formFactor: `ATX`,
    watt: `500W`,
    cert: `80 PLUS Bronze`,
    extra: `full range`,
    specs: `ATX | 500W | 80 PLUS Bronze | Full Range`,
    productUrl: `https://industrial.seasonic.com/product/atx-es2/`,
    datasheetUrl: null,
  }),

  makeSeasonicPsu({
    id: `ssp-500et2`,
    label: `SSP-500ET2`,
    formFactor: `ATX`,
    watt: `500W`,
    cert: `80 PLUS Bronze`,
    extra: `full range`,
    specs: `ATX | 500W | 80 PLUS Bronze | Full Range`,
    productUrl: `https://industrial.seasonic.com/product/atx-et2/`,
    datasheetUrl: `https://industrial.seasonic.com/wp-content/uploads/sites/2/2024/04/SSP-600-500-400-350ET2.pdf`,
  }),

  makeSeasonicPsu({
    id: `ssp-500js`,
    label: `SSP-500JS`,
    formFactor: `ATX`,
    watt: `500W`,
    cert: `80 PLUS Gold`,
    extra: `industrial PSU`,
    specs: `ATX | 500W | 80 PLUS Gold`,
    productUrl: `https://industrial.seasonic.com/de/products/`,
    datasheetUrl: null,
  }),

  makeSeasonicPsu({
    id: `ssp-500jt`,
    label: `SSP-500JT`,
    formFactor: `ATX`,
    watt: `500W`,
    cert: `80 PLUS Gold`,
    extra: `industrial PSU`,
    specs: `ATX | 500W | 80 PLUS Gold`,
    productUrl: `https://industrial.seasonic.com/de/products/`,
    datasheetUrl: null,
  }),

  makeSeasonicPsu({
    id: `ssp-550rt`,
    label: `SSP-550RT`,
    formFactor: `PS2`,
    watt: `550W`,
    cert: `80 PLUS Gold`,
    extra: `industrial PSU`,
    specs: `PS2 | 550W | 80 PLUS Gold`,
    productUrl: `https://industrial.seasonic.com/de/products/`,
    datasheetUrl: null,
  }),

  makeSeasonicPsu({
    id: `ssp-600es2`,
    label: `SSP-600ES2`,
    formFactor: `ATX`,
    watt: `600W`,
    cert: `80 PLUS Bronze`,
    extra: `full range`,
    specs: `ATX | 600W | 80 PLUS Bronze | Full Range`,
    productUrl: `https://industrial.seasonic.com/product/atx-es2/`,
    datasheetUrl: null,
  }),

  makeSeasonicPsu({
    id: `ssp-600et2`,
    label: `SSP-600ET2`,
    formFactor: `ATX`,
    watt: `600W`,
    cert: `80 PLUS Bronze`,
    extra: `full range`,
    specs: `ATX | 600W | 80 PLUS Bronze | Full Range`,
    productUrl: `https://industrial.seasonic.com/product/atx-et2/`,
    datasheetUrl: `https://industrial.seasonic.com/wp-content/uploads/sites/2/2024/04/SSP-600-500-400-350ET2.pdf`,
  }),

  makeSeasonicPsu({
    id: `ssp-600js`,
    label: `SSP-600JS`,
    formFactor: `ATX`,
    watt: `600W`,
    cert: `80 PLUS Gold`,
    extra: `industrial PSU`,
    specs: `ATX | 600W | 80 PLUS Gold`,
    productUrl: `https://industrial.seasonic.com/de/products/`,
    datasheetUrl: null,
  }),

  makeSeasonicPsu({
    id: `ssp-600jt`,
    label: `SSP-600JT`,
    formFactor: `ATX`,
    watt: `600W`,
    cert: `80 PLUS Gold`,
    extra: `industrial PSU`,
    specs: `ATX | 600W | 80 PLUS Gold`,
    productUrl: `https://industrial.seasonic.com/de/products/`,
    datasheetUrl: null,
  }),

  makeSeasonicPsu({
    id: `ssp-650cm`,
    label: `SSP-650CM`,
    formFactor: `ATX`,
    watt: `650W`,
    cert: `80 PLUS Gold`,
    extra: `120 mm fan, full range`,
    specs: `ATX | 650W | 80 PLUS Gold | 120 mm Fan | Full Range`,
    productUrl: `https://industrial.seasonic.com/de/products/`,
    datasheetUrl: null,
  }),

  makeSeasonicPsu({
    id: `ssp-650rt`,
    label: `SSP-650RT`,
    formFactor: `PS2`,
    watt: `650W`,
    cert: `80 PLUS Gold`,
    extra: `industrial PSU`,
    specs: `PS2 | 650W | 80 PLUS Gold`,
    productUrl: `https://industrial.seasonic.com/de/products/`,
    datasheetUrl: null,
  }),

  makeSeasonicPsu({
    id: `ssp-650tr`,
    label: `SSP-650TR`,
    formFactor: `ATX`,
    watt: `650W`,
    cert: `80 PLUS Titanium`,
    extra: `PFC F3, full range APFC`,
    specs: `ATX | 650W | 80 PLUS Titanium | PFC F3 | Full Range APFC`,
    productUrl: `https://industrial.seasonic.com/de/products/`,
    datasheetUrl: null,
  }),

  makeSeasonicPsu({
    id: `ssp-750cm`,
    label: `SSP-750CM`,
    formFactor: `ATX`,
    watt: `750W`,
    cert: `80 PLUS Gold`,
    extra: `120 mm fan, full range`,
    specs: `ATX | 750W | 80 PLUS Gold | 120 mm Fan | Full Range`,
    productUrl: `https://industrial.seasonic.com/de/products/`,
    datasheetUrl: null,
  }),

  makeSeasonicPsu({
    id: `ssp-750rs`,
    label: `SSP-750RS`,
    formFactor: `ATX`,
    watt: `750W`,
    cert: `80 PLUS Gold`,
    extra: `full range, 80 mm fan`,
    specs: `ATX | 750W | 80 PLUS Gold | Full Range | 80 mm Fan`,
    productUrl: `https://industrial.seasonic.com/product/atx-rs/`,
    datasheetUrl: `https://industrial.seasonic.com/wp-content/uploads/sites/2/2024/04/SSP-1000-850-750-650-RS.pdf`,
  }),

  makeSeasonicPsu({
    id: `ssp-750rt`,
    label: `SSP-750RT`,
    formFactor: `PS2`,
    watt: `750W`,
    cert: `80 PLUS Gold`,
    extra: `industrial PSU`,
    specs: `PS2 | 750W | 80 PLUS Gold`,
    productUrl: `https://industrial.seasonic.com/de/products/`,
    datasheetUrl: null,
  }),

  makeSeasonicPsu({
    id: `ssp-750tx`,
    label: `SSP-750TX`,
    formFactor: `ATX`,
    watt: `750W`,
    cert: `80 PLUS Titanium`,
    extra: `135 mm fan, fully modular`,
    specs: `ATX | 750W | 80 PLUS Titanium | 135 mm Fan | Fully Modular`,
    productUrl: `https://industrial.seasonic.com/de/products/`,
    datasheetUrl: null,
  }),
];
